export default __webpack_public_path__ + "static/media/mountain.3b1ee487.png";